module.exports = __webpack_public_path__ + "static/media/linhas-cantos.984b3aa3.svg";